<template>
  <div>
    <div class="page_title">查看权限</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div style="text-align:left;margin-bottom:15px">
          <span>角色名</span>
          <span class="rolename">系统管理员</span>
        </div>

        <!-- 角色权限查看 -->
        <div>
          <div class="role" v-for="(role1,index) in roleData" :key="index
        ">
            <div class="role1">
              <img src="@/assets/img/system/check.png" alt />
              <span>{{role1.module_name}}</span>
            </div>
            <div class="role2">
              <div class="role2_item" v-for="(role2,ind) in role1.list" :key="ind">
                <div class="role2_item1">
                  <img src="@/assets/img/system/check.png" alt />
                  <span>{{role2.module_name}}</span>
                </div>
                <div class="role2_item2">
                  <div v-for="(role3,i) in role2.list" :key="i">
                    <img src="@/assets/img/system/check.png" alt />
                    <span>{{role3.module_name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:30px;text-align:left">
          <el-button type="primary" round style="width:92px" @click="back">退出</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../../api/system";
import _ from "lodash";

export default {
  data() {
    return {
      roleData: [],
      role: {}
    };
  },
  methods: {
    getModuleList() {
      system
        .ModuleList()
        .then(res => {
          if (res.code == 0) {
            this.roleData = res.data.list;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //退出
    back() {
      history.back();
    }
  },
  created() {
    this.getModuleList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.rolename {
  display: inline-block;
  height: 23px;
  background-color: #e5f5e4;
  border-radius: 2px;
  margin-left: 20px;
  color: #669961;
  padding: 2px 5px;
}

.role:first-child {
  border-top: 1px solid #cfcece;
}
.role {
  width: 1000px;
  display: flex;
  border: 1px solid #cfcece;
  border-top: 1px solid transparent;
  justify-content: space-between;
  span {
    margin-left: 5px;
  }
  .role1 {
    width: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #cfcece;
    cursor: pointer;
  }
  .role2 {
    flex: 1;
    .role2_item {
      display: flex;
      border-bottom: 1px solid #cfcece;
      .role2_item1 {
        width: 170px;
        border-right: 1px solid #cfcece;
        line-height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .role2_item2 {
        width: 660px;
        display: flex;
        flex-wrap: wrap;
        div {
          line-height: 50px;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
    .role2_item:last-child {
      border-bottom: 1px solid transparent;
    }
  }
}
</style>

